import React, { useState, useEffect } from 'react';
import { useSnackbar } from 'notistack';

import {  Grid } from '@material-ui/core';
import ButtonComponent from '@components/Shared/Buttons/Button';
import { TitlePage } from '@src/@styles/styles.global';
import TableCollapsible from '@src/components/Shared/Tables/TableColapseNoPagination';

import InvisibleContent from '@src/components/Shared/InvisibleContent';

import Intencao from '@src/components/Shared/SolicitacaoAtendimento/Intencao';
import IntencaoMissa from '@src/components/Shared/SolicitacaoAtendimento/IntencaoMissa';
import ProgramaTv from '@src/components/Shared/SolicitacaoAtendimento/ProgramaTv';

interface ITest {

}

interface IProps {
  idPerfil: number;
}

const SolicitacaoAtendimento: React.FC<IProps> = ({
  idPerfil,
}) => {

  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);

  const [status, setStatus] = useState('');

  const [openIntencao, setOpenIntencao] = useState(false);
  const [openIntencaoMissa, setOpenIntencaoMissa] = useState(false);
  const [openProgramaTv, setOpenProgramaTv] = useState(false);
  const [data, setData] = useState<ITest[]>([]);

  const columnsLabel = {
  };

  useEffect(() => {
    window.document.title = 'CRM - Solicitações atendimento';
  }, []);

  return (
    <Grid container >

      <Grid
        container
        item
        lg={12}
        md={12}
        xs={12}
        style={{ margin: 5 }}
      >

        <Grid item lg={3 } md={3} xs={4} style={{ margin: 5 }}>
          <ButtonComponent
            //onClick={() => setOpenModalAddCorrespondencia(true)}
            fullWidth
            style={{ height: 46, borderRadius: 5 }}
            color={status === 'Intencao' ? 'secondary' : 'default'}
            onClick={() => (setStatus('Intencao'), setOpenIntencao(true), setOpenIntencaoMissa(false), setOpenProgramaTv(false))}
          >
            Pedido de oração
          </ButtonComponent>
        </Grid>

        <Grid item lg={3} md={3} xs={4} style={{ margin: 5 }}>
          <ButtonComponent
            fullWidth
            style={{ height: 46, borderRadius: 5}}
            color={status === 'Intencao missa' ? 'secondary' : 'default'}
            onClick={() => (setStatus('Intencao missa'), setOpenIntencaoMissa(true), setOpenIntencao(false), setOpenProgramaTv(false))}
          >
            Intenção de missa
          </ButtonComponent>
        </Grid>

        <Grid item lg={3} md={3} xs={4} style={{ margin: 5 }}>
          <ButtonComponent
            fullWidth
            style={{ height: 46, borderRadius: 5}}
            color={status === 'Programa TV' ? 'secondary' : 'default'}
            onClick={() => (setStatus('Programa TV'), setOpenProgramaTv(true), setOpenIntencao(false), setOpenIntencaoMissa(false))}
          >
            Programa TV
          </ButtonComponent>
        </Grid>


        <InvisibleContent visible={openIntencao === true}>
          <Intencao idPerfil={idPerfil} />
        </InvisibleContent>

        <InvisibleContent visible={openIntencaoMissa === true}>
        <IntencaoMissa idPerfil={idPerfil} />
        </InvisibleContent>

        <InvisibleContent visible={openProgramaTv === true}>
        <ProgramaTv idPerfil={idPerfil} />
        </InvisibleContent>

      </Grid>

      <InvisibleContent visible={openProgramaTv === false && openIntencao === false && openIntencaoMissa === false}>
      <Grid
        container
        justify="center"
        alignItems="center"
        item
        lg={12}
        md={12}
        xs={12}
        style={{ margin: 5 }}
      >
        <TableCollapsible
          loading={loading}
          columns={[columnsLabel]}
          FieldsBold={['']}
          data={data}
          keys={[

          ]}
       />
       </Grid>
      </InvisibleContent>

    </Grid>
  );
};

export default SolicitacaoAtendimento;
